module.exports = __webpack_public_path__ + "img/00023.b4f96565.webp";